export default {
    searchByDepartment: 'ค้นหาโดยแผนก',
    search: 'ค้นหา',
    createNewDepartment: 'สร้างแผนกใหม่',
    department: 'แผนก',
    description: 'คำอธิบาย',
    manager: 'ผู้จัดการ',
    managerContact: 'ติดต่อผู้จัดการ',
    contactNo: 'อีเมล์ผู้จัดการ',
    totalStaff: 'พนักงานทั้งหมด',
    action: 'แก้ไข',
    congratulation: 'ยินดีด้วย',
    deleteDepertment: 'ลบเเผนก',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบแผนก',
    departmentIsDeleted: 'แผนกถูกลบแล้ว'
}
